export const CASUAL_PAGE_CONFIG = {
  "title": "Country Comparison",
  "titleCN": "国家对比",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/comparisonAnalysis/countryComparison",
  "defaultTab": "country_comparison",
  "className": "dbd-country-comparison",
  "tabList": [
    {
      "id": "country_comparison",
      "isHaveNotification": true,
      "notificationPath": "/comparisonAnalysis/countryComparison",
      "path": "/comparisonAnalysis/countryComparison",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "201601",
        "pageName": "comparisonAnalysisCountryComparison",
        "extInfo": "comparisonAnalysisCountryComparison",
        "pagePath": "/comparisonAnalysis/countryComparison",
        "typeId": "dashboard_pc_v2"
      },
      "filters": [
        {
          "name": "CountryComparisonFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/comparisonAnalysis/countryComparison",
          "data": {
            "typeList": [
              "day",
              "week",
              "month"
            ]
          },
          "componentList": [

            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "CountryComparisonService",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "data": {
                    "metric": "new_users"
                  },
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/comparison_analysis/country/linechart",
                      "isDark": true,
                      "dataKey": "country_line_chart"
                    }
                  },
                  "children": [
                    {
                      "name": "MetricComponent",
                      "path": "comparisonAnalysis/countryComparison",
                      "componentKey": "SegmentTabsCo",
                      "config": {
                        "props": {
                          "config": {
                            "tabMetric": {
                              "Day": [
                                "total_users",
                                "new_users",
                                "active_users",
                                "iaa_revenue",
                                "ecpm",
                                "cpi",
                                "af_new",
                                "af_cpi",
                                "new_ch_organic_rate",
                                "fraud_active_users_rate",
                                "spend",
                                "roi",
                                "register_arpu",
                                "arpu",
                                "d2",
                                "d3",
                                "d4",
                                "d5",
                                "d6",
                                "d7",
                                "d14",
                                "d30",
                                "roas1",
                                "roas2",
                                "roas3",
                                "roas7",
                                "roas14",
                                "roas30",
                                "roas60",
                                "roas90",
                                "roas180",
                                "iaa_impressions",
                                "avg_active_user_matches",
                                "avg_new_user_matches",
                                "aot",
                                "new_aot",
                                "retention_users",
                                "churn_users",
                                "churn_rate",
                                "return_users",
                                "weighted_d2",
                                "weighted_d3",
                                "weighted_d7",
                                "first_login_ratio",
                                "second_login_ratio"
                              ],
                              "Week": [
                                "total_users",
                                "new_users",
                                "avg_dau",
                                "iaa_revenue",
                                "ecpm",
                                "cpi",
                                "ug_install",
                                "af_cpi",
                                "new_ch_organic_rate",
                                "fraud_active_users_rate",
                                "spend",
                                "roi",
                                "register_arpu",
                                "arpu",
                                "d2",
                                "d3",
                                "d4",
                                "d5",
                                "d6",
                                "d7",
                                "d14",
                                "d30",
                                "roas1",
                                "roas2",
                                "roas3",
                                "roas7",
                                "roas14",
                                "roas30",
                                "roas60",
                                "roas90",
                                "roas120",
                                "roas180",
                                "iaa_impressions",
                                "avg_active_user_matches",
                                "avg_new_user_matches",
                                "aot",
                                "new_aot",
                                "first_login_ratio",
                                "second_login_ratio"
                              ],
                              "Month": [
                                "total_users",
                                "new_users",
                                "avg_dau",
                                "iaa_revenue",
                                "ecpm",
                                "cpi",
                                "ug_install",
                                "af_cpi",
                                "new_ch_organic_rate",
                                "fraud_active_users_rate",
                                "spend",
                                "roi",
                                "register_arpu",
                                "arpu",
                                "d2",
                                "d3",
                                "d4",
                                "d5",
                                "d6",
                                "d7",
                                "d14",
                                "d30",
                                "roas1",
                                "roas2",
                                "roas3",
                                "roas7",
                                "roas14",
                                "roas30",
                                "roas60",
                                "roas90",
                                "roas120",
                                "roas180",
                                "iaa_impressions",
                                "avg_active_user_matches",
                                "avg_new_user_matches",
                                "aot",
                                "new_aot",
                                "first_login_ratio",
                                "second_login_ratio"
                              ]
                            },
                          }
                        }
                      }
                    }
                  ]
                },

                {
                  "name": "MetricComponent",
                  "path": "comparisonAnalysis/countryComparison",
                  "componentKey": "OverallTableCo",
                  "data": {
                    "tableMetric": {
                      "Day": [
                        "total_users",
                        "new_users",
                        "active_users",
                        "iaa_revenue",
                        "ecpm",
                        "cpi",
                        "ug_install",
                        "af_cpi",
                        "new_ch_organic_rate",
                        "fraud_active_users_rate",
                        "spend",
                        "roi",
                        "register_arpu",
                        "arpu",
                        "d2",
                        "d3",
                        "d4",
                        "d5",
                        "d6",
                        "d7",
                        "d14",
                        "d30",
                        "roas1",
                        "roas2",
                        "roas3",
                        "roas7",
                        "roas14",
                        "roas30",
                        "roas60",
                        "roas90",
                        "roas180",
                        "iaa_impressions",
                        "avg_active_user_matches",
                        "avg_new_user_matches",
                        "aot",
                        "new_aot",
                        "retention_users",
                        "churn_users",
                        "churn_rate",
                        "return_users",
                        "weighted_d2",
                        "weighted_d3",
                        "weighted_d7",
                        "first_login_ratio",
                        "second_login_ratio"
                      ],
                      "Week": [
                        "total_users",
                        "new_users",
                        "avg_dau",
                        "iaa_revenue",
                        "ecpm",
                        "cpi",
                        "ug_install",
                        "af_cpi",
                        "new_ch_organic_rate",
                        "fraud_active_users_rate",
                        "spend",
                        "roi",
                        "register_arpu",
                        "arpu",
                        "d2",
                        "d3",
                        "d4",
                        "d5",
                        "d6",
                        "d7",
                        "d14",
                        "d30",
                        "roas1",
                        "roas2",
                        "roas3",
                        "roas7",
                        "roas14",
                        "roas30",
                        "roas60",
                        "roas90",
                        "roas120",
                        "roas180",
                        "iaa_impressions",
                        "avg_active_user_matches",
                        "avg_new_user_matches",
                        "aot",
                        "new_aot",
                        "first_login_ratio",
                        "second_login_ratio"
                      ],
                      "Month": [
                        "total_users",
                        "new_users",
                        "avg_dau",
                        "iaa_revenue",
                        "ecpm",
                        "cpi",
                        "ug_install",
                        "af_cpi",
                        "new_ch_organic_rate",
                        "fraud_active_users_rate",
                        "spend",
                        "roi",
                        "register_arpu",
                        "arpu",
                        "d2",
                        "d3",
                        "d4",
                        "d5",
                        "d6",
                        "d7",
                        "d14",
                        "d30",
                        "roas1",
                        "roas2",
                        "roas3",
                        "roas7",
                        "roas14",
                        "roas30",
                        "roas60",
                        "roas90",
                        "roas120",
                        "roas180",
                        "iaa_impressions",
                        "avg_active_user_matches",
                        "avg_new_user_matches",
                        "aot",
                        "new_aot",
                        "first_login_ratio",
                        "second_login_ratio"
                      ]
                    }
                  },

                  "config": {
                    "props": {
                      "config": {
                        "isHaveDiff": false,
                        "useTime": true,
                        "showStatistic": [
                          "sum",
                          "avg_no_null"
                        ],
                        "slotConfig": {
                          "isShowdownloadConfig": false
                        },
                        "valueTypeConfig": {
                          "valueType": "value_only",
                          "isShowChange": false
                        },
                        "dimensionConfig": {
                          "dateDisabled": false,
                          "defaultAccumulation": [
                            "date",
                            "country"
                          ],
                          "isShowCountryFlag": true
                        },
                        "api": {
                          "tableApi": "/api/v1/dashboard/comparison_analysis/country/overall_performance",
                          "tableDownloadApi": "/api/v1/dashboard/comparison_analysis/country/overall_performance/download"
                        },
                        "titleEn": "Key Metrics Ranking",
                        "titleCn": "关键指标排名"
                      }
                    }
                  }

                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
